export default "__VITE_ASSET__CPFxXxJX__"